const IMAGES = {
    chevron: require(`./chevron.png`),
    banner: require(`./banner.png`),
    filter:require(`./filter.png`),
    VFloader:require(`./loader.png`),
    close:require(`./close.png`),
    editIcon:require(`./edit.png`),
    arrowup:require(`./arrowup.png`),
    arrowdown:require(`./downarrow.png`),
    vfPops:require(`./vf-pops.png`),
    companyPops:require(`./company-pops.png`),
    vfPopsHover:require(`./vf-pops-hover.png`),
    companyPopsHover:require(`./company-pops-hover.png`),
    arrowright:require(`./arrowright.png`),
    chevronredleft:require(`./chevronredleft.png`),
    chevronredright:require(`./chevronredright.png`),
    success:require(`./success.png`),
    contact:require(`./contact.png`),
    loginBg:require(`./login-bg.png`),
    save:require(`./save.png`),
    eyeIcon:require(`./eye-icon.png`),
    error:require(`./error.png`),
    user:require(`./user.png`),
    logo:require(`./logo.png`),
    notification:require(`./notification.png`),
    ammendService: require(`./ammend.png`),
    downloadExcel: require(`./downloadExcel.png`),
    tier1Icon : require(`./marker1.png`),
    tier2Icon : require(`./marker2.png`),
    // otherTierIcon : require(`./marker3.png`),
    // availedTierIcon : require(`./marker4.png`),
    otherTierIcon : require(`./marker5.png`),
    availedTierIcon : require(`./marker6.png`),
    chevronOpen: require(`./chevronOpen.png`),
    chevronClose: require(`./chevronClose.png`),
    attach: require(`./attach.png`),
    comment: require(`./comment.png`),
    back: require(`./back.png`),
    infoCircle: require(`./info_circle.png`),
    infoCirclered: require(`./info_circle_red.png`),
    attachment: require(`./attachmentlogo.png`),
    downloadlogo: require(`./downloadlogo.png`),
    attachinfo: require(`./attachinfo.png`),
    attachment_icon:require(`./attachment_icon.png`),
    downloadfile:require(`./downloadfile.png`),
    backarrow:require(`./back_arrow.png`),
    newcomment:require(`./newcomment.png`),
    onboardinfo:require(`./onboardinfo.png`),
    editrole:require(`./editrole.png`),
    attachmenticon:require(`./attachmenticon.png`),
    lastlogin:require(`./lastlogin.png`),
    userinfosearch:require(`./userinfosearch.png`),
    primary:require(`./primary.png`),
    arrows:require(`./arrows.png`),
    searchicon:require(`./searchicon.png`),
    eyeicon:require(`./eyeicon.png`),
    pdfLogo:require(`./pdfLogo.png`),
    jpgLogo:require(`./jpgLogo.png`),
    pngLogo:require(`./pngLogo.png`),
    xlsxLogo:require(`./xlsxLogo.png`),
    docLogo:require(`./docLogo.png`),
    download:require(`./download.png`),
    filtericon:require(`./filtericon.png`),
    noinvoice:require(`./noinvoice.png`),
    copy:require(`./copy.png`),
    selectedarrow:require(`./selectedarrow.png`),
    reseticon:require(`./reseticon.png`),
    sorticon:require(`./sorticon.png`),
    clock:require(`./clock.png`),
    arrowup:require(`./Chevronup.png`),
    clockblack:require(`./clockblack.png`),
    searchimage:require(`./searchimage.png`),
    questionicon:require(`./questionicon.png`),
    addicon:require(`./addicon.png`),
    disablesave:require(`./disablesave.png`),
    Vector:require(`./Vector.png`),
    montharrow:require(`./montharrow.png`),
    downloadxlxs:require(`./downloadxlxs.png`),
    closeicon:require(`./closeicon.png`),
    newbanner: require(`./newbanner.png`),
    popimage: require('./popimage.png'),
    quicklink: require('./quicklink.png'),
    addlink: require('./addlink.png'),
    worldmap: require('./worldmap.png'),
    boradcast:require('./broadcast.png'),
    boradcastopen:require('./broadcastopen.png'),
    nodata: require('./nodata.png'),
    deleteicon: require('./deleteicon.png'),
    newdashboard:require('./newdashboard.png'),
    messageicon:require('./messageIcon.png'),
    retryicon:require('./retryicon.png'),
    usericon:require('./usericon.png'),
    bellicon:require('./bellicon.png'),
    disableretry:require('./disableretry.png'),
    activeviewicon:require('./activeviewicon.png'),
    disableviewicon:require('./disableviewicon.png'),
    globe:require('./globe.png'),
    crossIcon:require('./crossIcon.png'),
    rightIcon:require('./rightIcon.png'),
    retry:require('./retry.png'),
    hidepassword:require('./hidepassword.png'),
    editlink:require('./editlink.png'),
    timeicon:require('./timeicon.png'),
    rightarrow:require('./rightarrow.png'),
    downchevron:require('./downchevron.png'),
    vfbanner:require('./vfbanner.png'),
    // popsIcon:require('./LocationIcon.png'),
    popsIcon:require('./combinedmarker.png'),
    vfipxclustor:require('./vfipxclustor.png'),
    myconnectivityclustor:require('./myconnectivityclustor.png'),
    remove:require('./delete.png'),
    send:require('./sendmessage.png'),
    iconattach:require('./Iconattach.png'),
    actionIcon:require('./actionIcon.png'),
    demandStage:require('./demandStage.png'),
    demand: {
    neutral: require('./demandps.png'),
    filled: require('./demandps.png'),
    },
    quotation: {
    neutral: require('./quotationStageneutral.png'),
    filled: require('./quotationStage.png'),
    },
    orderForm: {
        neutral: require('./orderFormStageneutral.png'),
        filled: require('./orderFormStage.png')
    },
    serviceBuilding: {
        neutral: require('./serviceBuildingStageneutral.png'),
        filled: require('./serviceBuildingStage.png')
    },
    billingOnboarding: {
        neutral: require('./billingOnboardingStageneutral.png'),
        filled: require('./billingOnboardingStage.png')
    },
    goLive: {
        neutral: require('./goLiveStageneutral.png'),
        filled: require('./goLiveStage.png')
    },
    downloadWhite:require('./downloadwhite.png'),
    messageActionIcon:require('./messageActionIcon.png'),
    iconpre:require('./iconpre.png'),
    iconhover:require('./iconhover.jpg'),
    badge:require('./badge.png'),
    notificationAction:require('./notificationAction.png'),
    calender:require('./calender.jpg'),
}

export default IMAGES